"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.makeDefaultInitOptions = void 0;
const makeDefaultInitOptions = (namespaces) => {
    return {
        debug: false,
        lng: undefined,
        fallbackLng: false,
        fallbackNS: false,
        keySeparator: false,
        load: 'currentOnly',
        defaultNS: false,
        ns: namespaces,
        nsSeparator: '|NS|',
        pluralSeparator: '_',
        contextSeparator: '|CTX|',
    };
};
exports.makeDefaultInitOptions = makeDefaultInitOptions;
//# sourceMappingURL=makeDefaultInitOptions.js.map